import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Playlist from '../../models/Playlist';
import RenderUser from '../RenderUser';

interface PlaylistItemProps {
    playlist: Playlist;
    visibleCheck?: boolean;
    isChecked?: boolean;
    onChecked?: (playlist: Playlist) => void;
};

const PlaylistItem: React.FC<PlaylistItemProps> = (props: PlaylistItemProps) => {

    const isChecked = props.isChecked ?? false;
    const batchActive = props.visibleCheck ?? false;

    const _handleLinkClick = (e: React.MouseEvent) => {
        if (batchActive) e.preventDefault();
    };

    return(
        <div
            className="card mb-3"
            style={batchActive ? { cursor: 'pointer' } : undefined}
            onClick={batchActive ? () => props.onChecked?.(props.playlist) : undefined}
        >
            <div className={`card-body playlist-item${isChecked ? ' checked' : ''}`}>
                <Link
                    to={`playlists/${props.playlist.id}`}
                    className="playlist-item__name"
                    onClick={_handleLinkClick}
                >
                    <i className="iconsminds-check"></i>
                    <span className="ml-2">{ props.playlist.name }</span>
                </Link>
                <div className="playlist-item__actions">
                    <RenderUser item={props.playlist} />
                    <Link
                        to={`playlists/${props.playlist.id}`}
                        className="playlist-item__detail-link"
                        onClick={_handleLinkClick}
                    >
                        <FontAwesomeIcon icon={faChevronRight} />
                    </Link>
                </div>
            </div>
        </div>
    );

};

export default React.memo(PlaylistItem);
